<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <polyline points="14,4 20,4 20,10"/>
    <line x1="10" y1="14" x2="20" y2="4"/>
    <polyline points="20,14 20,20 4,20 4,4 10,4"/>
  </svg>
</template>
